export default __webpack_public_path__ + "static/media/outline-file_copy-24px.2a2ff1a0.svg";